import { render, staticRenderFns } from "./ModalEditSpaceEventTypes.vue?vue&type=template&id=197d901e"
import script from "./ModalEditSpaceEventTypes.vue?vue&type=script&lang=js"
export * from "./ModalEditSpaceEventTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports